import RequestAbstract from "../abstract";

export default class InviteCodes extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/invite-codes";
    }
}
